<script lang="ts" setup>
import { useCommon } from '~/composables/common/use-common'
import { contactUs } from '~/resources/common/contact-us'
import { useContact } from '~composables/common/use-contact.ts'

const { openLinkContact } = useCommon()
const { telegramSupport, fetchContact } = useContact()
fetchContact()
</script>
<template>
  <div class="ctn-chat-bubble">
    <div class="chat-bubble">
      <div class="chat-bubble__item" @click="openLinkContact(contactUs)">
        <div class="chat-bubble__icon">
          <NuxtImg
            format="webp"
            :src="contactUs.img"
            :alt="contactUs.title"
            width="32"
            height="32"
            quality="100"
            preload
          />
        </div>
        <div class="box-contact__name">
          {{ contactUs.title }}
        </div>
      </div>
      <ClientOnly>
        <NuxtLink v-if="telegramSupport?.link" :to="telegramSupport?.link" target="_blank" class="chat-bubble__item">
          <div class="chat-bubble__icon">
            <NuxtImg
              format="webp"
              src="/assets/images/icons/icon-telegram.png"
              alt="Telegram"
              width="32"
              height="32"
              quality="100"
              preload
            />
          </div>
          <div class="box-contact__name">Telegram</div>
        </NuxtLink>
      </ClientOnly>
    </div>
  </div>
</template>
<style lang="scss" scoped src="~scssAsset/components/common/live-chat.scss"></style>
